module.exports = __webpack_public_path__ + "../resources/img/bg_load1_01.c2a6135e.png";